<template>
  <div class="auth-input-page">
    <!-- <div>
      <div class="d-flex justify-space-between align-center gap-20">
        <div class="auth-plan__title">Payment</div>
        <v-menu
          bottom
          left
          offset-y
          :nudge-top="-5"
          :nudge-left="0"
          content-class="auth-plan__content"
        >
          <v-select
            class="py-0 auth-plan__select"
            single-line
            hide-details
            slot="activator"
            :placeholder="
              selectedPlan
                ? `${selectedPlan.title} - $${selectedPlan.price}/month`
                : 'Choose'
            "
          >
          </v-select>

          <div v-if="accountCategory == 'creator'">
            <div
              v-for="(artist_plan, i) in artist_plans"
              :key="i"
              v-on:click.capture="selectplanTab(artist_plan)"
            >
              <div class="d-flex align-center">
                <div>{{ artist_plan.title }} -</div>
                <div>
                  <span>${{ artist_plan.price }}</span>
                  <span>/month</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              v-for="(listener_plan, i) in listener_plans"
              :ripple="true"
              :key="i"
              @click="selectplanTab(listener_plan)"
            >
              <div class="d-flex align-center">
                <div>{{ artist_plan.title }} -</div>
                <div>
                  <span>${{ artist_plan.price }}</span>
                  <span>/month</span>
                </div>
              </div>
            </div>
          </div>
        </v-menu>
      </div>
    </div>

    <payment-card :item="selectedPlan" :totalPayable="totalPayable" /> -->

    <payment-success ref="paymentSuccess" :account-category="accountCategory" />
  </div>
</template>

<script>
import PaymentCard from "@/components/paymentCard/index";
import PaymentSuccess from "@/components/paymentCard/paymentSuccess";
import { mapActions, mapState } from "vuex";
import { Stripe } from "@/helper";
import UserService from "@/services/user.js";

export default {
  components: {
    PaymentCard,
    PaymentSuccess,
  },
  data() {
    return {
      initPayment: false,
      selectedPlan: {},
      accountCategory: "",
      artist_plans: [
        {
          id: "free",
          title: "Free",
          price: 0,
          list: [],
        },
        {
          id: "standard",
          title: "Standard",
          price: 29,
          list: [
            "All access / No Ads",
            "Sell products & keep 100%",
            "Share to Earn $2/month / person",
            "Upload music, videos, PPV",
            "Collections & playlists",
            "Offline listening",
          ],
        },
        {
          id: "business",
          title: "Business",
          price: 299,
          list: [
            "All access / No Ads",
            "Sell products & keep 100%",
            "Share to Earn $2/month / person",
            "Upload music, videos, PPV",
            "Collections & playlists",
            "Offline listening",
          ],
        },
      ],
      listener_plans: [
        {
          id: "free",
          title: "Free",
          price: 0,
          list: [],
        },
        {
          id: "listener",
          title: "Listener",
          price: 12,
          list: [
            "All access / No Ads",
            "Collections & playlists",
            "Offline listening",
            "Share to earn $2.month/person",
          ],
        },
        {
          id: "vip",
          title: "VIP",
          price: 48,
          list: [
            "All access / No Ads",
            "Collections & playlists",
            "Offline listening",
            "Share to earn $2.month/person",
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      plansData: (state) => state.app.plansData,
      current: (state) => state.app.onboarding.current,
      getAccountCategory: (state) => state.app.onboarding.accountCategory,
    }),
    plans() {
      return this.plansData.filter((plan) => plan.id != "basic");
    },
    totalPayable() {
      const fee = parseFloat(this.selectedPlan.price);
      const subFee = Stripe.calculateSubFee(this.selectedPlan.price);

      let total = parseFloat(subFee) + parseFloat(fee);
      total = parseFloat(total.toFixed(2));

      return total;
    },
  },
  methods: {
    ...mapActions({
      gotoNextStage: "app/nextOnboardingStage",
    }),
    makeListener() {
      const params = { id: this.$store.state.app.onboarding.username };
      UserService.changeCreatorRoleIntoListener(params)
        .then((response) => {
          this.$store.dispatch("error/showSuccessToast", [response.bodyText]);
        })
        .catch((e) => {
          this.$store.dispatch("error/showErrorToast", [
            "There was an error on updating user role.",
          ]);
        });

      this.handleNextStage();
    },

    handleNextStage() {
      this.gotoNextStage(this.current + 1);
    },

    selectplanTab(plan) {
      this.selectedPlan = plan;
    },
    openPaymentSuccess() {
      this.$refs.paymentSuccess.openPaymentSuccess();
    },
  },
  created() {
    this.accountCategory = this.getAccountCategory;
  },
  mounted() {
    this.openPaymentSuccess();
    if (this.accountCategory == "creator") {
      this.selectedPlan = this.artist_plans[0];
    } else {
      this.selectedPlan = this.listener_plans[0];
    }
  },
};
</script>

<style lang="scss" scoped>
.auth-plan {
  &__title {
    color: #333;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
  }
  &__select {
    ::v-deep .input-group__selections input {
      color: #000;
      font-feature-settings: "clig" off, "liga" off;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// authPlan.vue?6bf3ed61